import DPDropDown from 'framework/components/DPDropDown';
import DPTextBox from 'framework/components/DPTextBox';
import { Text, Numeric } from 'framework/validators/TextValidation';
import React from 'react';
import { Col, Row } from 'reactstrap';



export const ExcelFromSPContent = ({
    handleChange,
    parameters,
    formValues,
    spDropdownList,
    selectedDropdown,
    setSelectedDropdownOnChange
}) => {
    return (
        <Row>
            <Col md={6}>
                <DPDropDown
                    optionGroup={spDropdownList}
                    selectedGroup={selectedDropdown}
                    onChange={setSelectedDropdownOnChange}
                    labelText={"Select Stored Procedure"}
                />

                {parameters.map(param => {

                    if (param.mode == 'IN') {
                        return (
                            <div key={param.name}>
                                <DPTextBox
                                    labelText={param.name.toString().replace('@', '')}
                                    value={formValues[param.name]}
                                    onChange={(e) => {

                                        let currentValue = e.target.value;

                                        if (param.dataType == 'numeric' || param.dataType == 'decimal' || param.dataType == 'int') {

                                            let decimalPalces = param.dataType == 'decimal' || param.dataType == 'numeric' ? 2 : 0;

                                            currentValue = Numeric(e.target, 10, decimalPalces, false)

                                        } else if (param.dataType == 'date' || param.dataType == 'datetime' || param.dataType == 'time') {
                                            currentValue = e.target.value
                                        } else {
                                            currentValue = Text(e.target, param.maxLength, true, true, 'any', true)
                                        }

                                        handleChange(param.name, e.target.value)

                                    }}
                                    maxLength={param.maxLength || ''}
                                    name={param.name}
                                    textType={param.dataType || 'text'}
                                />
                            </div>
                        )
                    }
                }
                )}
            </Col>
        </Row>
    )
}

